import { render, staticRenderFns } from "./FileButton.vue?vue&type=template&id=73bf1ade&"
import script from "./FileButton.vue?vue&type=script&lang=js&"
export * from "./FileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports